// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "foxit-UIExtension-full" + "." + "7ea6f9df5b8fb76d" + ".js";
};